import {h} from 'preact';
import {useEffect, useState} from "preact/compat";

export default function SelectInput({onChange, placeholder, items, name, getItemValue, getItemName, isCheckedValue, checkedItem}){
	const [value, setValue] = useState(placeholder);
	if (value !== placeholder && (typeof checkedItem === "undefined" || checkedItem.length === 0) ) setValue(placeholder);
	return (
		<div className='select form-field__select js__tabselect'>
			<button className="select__button" type="button" data-dsdd>
				<span data-placeholder={placeholder}>{value}</span>
			</button>
			<ul className="select__list dsdd-menu select-has-scrollbar">
				{
					items.map((item) => {
						const checked = isCheckedValue(item);
						if (checked) setValue(getItemName(item));
						return (
							<li className="select__item">
								<label className="select__item-btn">
									<input className="select__input" checked={checked} value={getItemValue(item)} onChange={onChange} type="radio" name={name}/><span className="select__label">{getItemName(item)}</span>
								</label>
							</li>
						);
					})
				}
			</ul>
		</div>
	)
}
